import { Injectable } from '@angular/core';
import { concatMap, filter, tap } from 'rxjs';
import { UserState } from '../../../shared/state';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
export class GoogleAnalyticsService {
  store;
  loggedInUser;
  getProfileDataSubscription;
  userId = '';
  constructor(store) {
    this.store = store;
    this.getProfileDataSubscription = this.store.select(UserState.token).pipe(filter(token => !!token), concatMap(() => this.store.select(UserState.user))).pipe(tap(user => this.userId = user.userId ?? ''), filter(user => !!user.userId && !this.loggedInUser)).subscribe(user => {
      this.loggedInUser = user;
    });
  }
  ngOnDestroy() {
    this.getProfileDataSubscription.unsubscribe();
  }
  metaPush(page) {
    let traffic = 'no';
    if (this.loggedInUser?.memberships?.find(membership => membership.roles.includes('gea-employee'))) {
      traffic = 'yes';
    }
    // Needed like this for Google Analytics
    /* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
    // @ts-ignore
    window.dataLayer?.push({
      event: 'pageMeta',
      user_logged_in: 'yesloggedin',
      user_id: this.userId,
      customer_country: this.loggedInUser?.country,
      user_language: this.loggedInUser?.language,
      page_type: page,
      internalTraffic: traffic
    });
    /* eslint-enable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
  }
  loggedInPush(path) {
    // Needed like this for Google Analytics
    /* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
    // @ts-ignore
    window.dataLayer?.push({
      event: 'login',
      eventCategory: 'login',
      eventAction: this.userId || 'undefined',
      //please pass the customer ID
      eventLabel: path || 'undefined' // URL-Path
    });
    /* eslint-enable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
  }
  loggedOutPush(path) {
    // Needed like this for Google Analytics
    /* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
    // @ts-ignore
    window.dataLayer?.push({
      event: 'logout',
      eventCategory: 'logout',
      eventAction: this.userId || 'undefined',
      //please pass the customer ID
      eventLabel: path || 'undefined' // URL-Path
    });
    /* eslint-enable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
  }
  deleteWidgetPush(widget) {
    // Needed like this for Google Analytics
    /* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
    // @ts-ignore
    window.dataLayer?.push({
      event: 'widget',
      category: 'widget',
      action: 'delete',
      label: widget
    });
    /* eslint-enable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
  }
  editWidgetPush(widget) {
    // Needed like this for Google Analytics
    /* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
    // @ts-ignore
    window.dataLayer?.push({
      event: 'widget',
      category: 'widget',
      action: 'edit',
      label: widget
    });
    /* eslint-enable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
  }
  addWidgetPush(widget) {
    // Needed like this for Google Analytics
    /* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
    // @ts-ignore
    window.dataLayer?.push({
      event: 'widget',
      category: 'widget',
      action: 'add',
      label: widget
    });
    /* eslint-enable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
  }
  multiselectPush(widgets, count) {
    // Needed like this for Google Analytics
    /* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
    // @ts-ignore
    window.dataLayer?.push({
      event: 'widget',
      category: 'widget',
      action: 'multiselect ' + count.toString(),
      label: widgets
    });
    /* eslint-enable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
  }
  viewWidgetPush(widget) {
    // Needed like this for Google Analytics
    /* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
    // @ts-ignore
    window.dataLayer?.push({
      event: 'widget',
      category: 'widget',
      action: 'view',
      label: widget
    });
    /* eslint-enable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
  }
  navigationPush(component, componentItem) {
    // Needed like this for Google Analytics
    /* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
    // @ts-ignore
    window.dataLayer?.push({
      event: 'navigation',
      eventCategory: 'navigation',
      eventAction: component,
      eventLabel: componentItem
    });
    /* eslint-enable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call */
  }
  static ɵfac = function GoogleAnalyticsService_Factory(t) {
    return new (t || GoogleAnalyticsService)(i0.ɵɵinject(i1.Store));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: GoogleAnalyticsService,
    factory: GoogleAnalyticsService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GoogleAnalyticsService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.Store
  }], null);
})();
